module.exports = __webpack_public_path__ + "static/media/react.05a3e30f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Languages/img/react.svg
// module id = 113
// module chunks = 0